import { Navigate, Outlet } from 'react-router-dom';
import { hasCapability } from './session';

const CapabilityRoute = ({ capability, fallback = '/' }) => {
  const capabilities = Array.isArray(capability) ? capability : [capability];
  const allowed = capabilities.some((item) => hasCapability(item));
  if (!allowed) {
    return <Navigate to={fallback} replace />;
  }
  return <Outlet />;
};

export default CapabilityRoute;
